import React, { Component } from 'react'
import Select from 'react-select'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import RaisedButton from 'material-ui/RaisedButton';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper;

export default class IntrusionAlertList extends Component {

  constructor(props) {
    super(props);
    let x = new Date();
    x.setHours(0,0,0,0);
    this.state = {
      room_num: -1,
      ch_in_time: null,//x,
      ch_out_time: null,//new Date(),
      all_rooms: [],
      spinner: null,
      maxDate: new Date(),
      all_requests: [],
      current_offset: 0,
      activePage: 1,
      maxItems: 10,
      totalCount: 10,
      selectedId: this.props.selectedId,
      service_ids: this.props.service_ids ? this.props.service_ids : '',
      service_name: this.props.service_name ? this.props.service_name : '',
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
    this.getAllRooms();
  }

  getAllRooms() {
    let user = ls.getUserDetails()
    if (user.hotel_id) {
      ds.getAllRooms(user.hotel_id,
        data => {
          if (data && data.length) {
            for (let i of data) {
              i.label = i.hotel_room_id ? i.hotel_room_id.name : '';
              i.value = i.hotel_room_id._id;
            }
          }
          this.setState({
            all_rooms: data,
          })
        }, error => {
          console.log(error);
        })
    }
  }

  componentDidMount() {
    this.getAllRequests(this.state.current_offset,0,0);
    window.addEventListener('_mqt', (e) => {
      if (e && e.detail && e.detail.act_type == "new_alert") {
        this.props.serviceChange(e.detail)
        this.refreshTable();
      }
 })
  }

  componentWillUnmount() {
    window.removeEventListener('_mqt', (data) => { console.log(data) })
}


  onChangePage(e) {
    this.getAllRequests(this.state.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }


  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleChange = (e, index, value) => this.setState({ 'room_num': value });

  clearUnseenCount() {
    let c = [];
    for (let i of this.state.all_requests) {
      if (!i.seen) {
        c.push(i._id);
      }
    }

    if (c.length) {
      ds.postChangeUnseenAlertCount({
        alert_ids: c
      }, 
      data => {
        this.setState({
          unseen_count: this.state.unseen_count - c.length
        });
      }, 
      err => {})
    }
  }

  getAllRequests(offset, offset_change = 0, submit = 0, flag = 1) {
    let payload = {
        hotel_id:ls.getUserDetails().hotel_id,
        limit: this.state.maxItems,
        offset: offset
    };
    if(this.state.room_num != -1){
        payload.hotel_room_id = this.state.room_num;
    }
    if(flag && this.state.ch_in_time && this.state.ch_out_time ) {
        payload.start_date = this.state.ch_in_time;
        payload.end_date = this.state.ch_out_time;
    }
    ds.getIntrusionHistory(payload,
      data => {
        if (data.intrusion_history && data.intrusion_history.length) {
          for (let row of data.intrusion_history) {
            if (row.timestamp) {
              let cell = row.timestamp * 1000;
              let x = new Date(cell);
              row.time = x && x != 'Invalid Date' ? x.toLocaleString() : 'Unknown'
              row.date = x && x != 'Invalid Date' ? x.toDateString() : 'Unknown'
            }
          }
        }

        this.setState({
          all_requests: data.intrusion_history,
          totalCount: data.count

        }, () => {
          this.clearUnseenCount();
        });

        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.state.maxItems
          });
        }
      }, err => {}, 
      [this.state.service_ids]
    );
  }

  refreshTable(e) {
    this.getAllRequests(this.state.current_offset - this.state.maxItems > 0 ? this.state.current_offset - this.state.maxItems : 0, 1);
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.state.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />

    return (<div>
      <div className="col-sm-12" style={{display:"grid"}}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>
        <div className="col-sm-12">
            <div className="col-sm-6">
                <Select
                      id="room_numid"
                      ref={(ref) => { this.select = ref; }}
                      onBlurResetsInput={false}
                      onSelectResetsInput={false}
                      autoFocus
                      options={this.state.all_rooms}
                      simpleValue
                      clearable={true}
                      name="room_num"
                      disabled={false}
                      value={this.state.room_num}
                      onChange={(newValue) => {
                        this.setState({
                          room_num: newValue,
                        })
                      }}
                      searchable={true}
                      placeholder="Room Number"
                      style={{ marginTop: "15px" }}
                    />
                    </div>
                    </div>
                    <div className="col-sm-12">
                     <div className="mt-1vw col-sm-4">
                    <div className="false-placeholder">From Date & Time</div>

                    <DatePicker
                      hintText="From Date"
                      container="inline"
                      name="ch_in_time"
                      className="col-sm-5 w-100"
                      maxDate={this.state.maxDate}
                      value={this.state.ch_in_time}
                      autoOk
                      style={{
                        maxWidth: '50%'
                      }}
                      onChange={(e, value) => {
                        this.setState({
                          ch_in_time: value
                        })
                      }} 
                    />

                    <TimePicker
                      format="ampm"
                      autoOk
                      hintText="From Time"
                      className="col-sm-5 w-100"
                      value={this.state.ch_in_time}
                      onChange={(e, value) => {
                        this.setState({
                          ch_in_time: value
                        })
                      }}
                    />
                  </div>

                  <div className="mt-1vw col-sm-4">
                    <div className="false-placeholder">To Date & Time</div>

                    <DatePicker
                      hintText="To Date"
                      container="inline"
                      name="ch_out_time"
                      className="col-sm-5 w-100"
                      value={this.state.ch_out_time}
                      autoOk
                      style={{
                        maxWidth: '50%'
                      }}
                      onChange={(e, value) => {
                        this.setState({
                          ch_out_time: value
                        })
                      }} 
                    />

                    <TimePicker
                      format="ampm"
                      autoOk
                      hintText="To Time"
                      className="col-sm-5 w-100"
                      value={this.state.ch_out_time}
                      onChange={(e, value) => {
                        this.setState({
                          ch_out_time: value
                        })
                      }}
                    />
                  </div>
                  </div>
                  <div className="mt-1vw col-sm-12" style={{paddingLeft:'30px'}}>
                  <RaisedButton
                    label="Submit"
                    primary
                    type="submit"
                    onClick={()=>{
                        this.getAllRequests(this.state.current_offset - this.state.maxItems > 0 ? this.state.current_offset - this.state.maxItems : 0, 1,1)
                    }}
                  />
                </div>

        <Table
          height={'50vh'}
          fixedHeader={true}
          fixedFooter={true}
          selectable={false}
          multiSelectable={false}
          style={{ minWidth: 400 }}
          bodyStyle={{ minWidth: 400, overflowX: 'auto' }}
        >
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn tooltip="Room Number">Room Number</TableHeaderColumn>
              {
                window.screen.width >= 650 ? 
                  <TableHeaderColumn tooltip="Requested Date">Time</TableHeaderColumn> 
                : null
              }

              <TableHeaderColumn tooltip="Device Name">
                Device Name
              </TableHeaderColumn> 

              <TableHeaderColumn tooltip="Switch Name">
                Switch Name
              </TableHeaderColumn> 

              <TableHeaderColumn tooltip="Device Name">
                Device State
              </TableHeaderColumn> 

              {/* <TableHeaderColumn className="align-center">Action</TableHeaderColumn> */}
            </TableRow>
          </TableHeader>

          <TableBody
            displayRowCheckbox={false}
            showRowHover={true}
            stripedRows={false}
          >
            {
              this.state.all_requests.map((row, index) => (
                <TableRow key={index}>
                  <TableRowColumn >
                    <div style={{ fontSize: "2rem" }}>{row.hotel_room_name ? row.hotel_room_name : 'NA'}</div>
                    {
                      window.screen.width < 650 ? 
                        <div style={{ fontSize: "0.7rem", paddingLeft: "0.3rem", paddingTop: "0.3rem", color: "gray" }}>{row.time}</div> 
                      : null
                    }
                  </TableRowColumn>

                  {
                    window.screen.width >= 650 ? 
                      <TableRowColumn>{row.time}</TableRowColumn> 
                    : null
                  }

                  <TableRowColumn >
                    {
                    //   row.meta && row.meta[0] && row.meta[0].name ? 
                        <div style={{ fontSize: "0.7rem", paddingLeft: "0.3rem", paddingTop: "0.3rem" }}>
                          {
                            row.device_name
                            // row.meta.map((item, index1) => {
                            //   return <li key={index1+'___Some___Random__Thing'} className="font-1-2rem mb-0-4rem">
                            //     { item.name } x{item.quantity}
                            //   </li>
                            // })
                          }
                        </div> 

                    //   : 'NA'
                    }
                  </TableRowColumn>
                  <TableRowColumn >
                    {
                    //   row.meta && row.meta[0] && row.meta[0].name ? 
                        <div style={{ fontSize: "0.7rem", paddingLeft: "0.3rem", paddingTop: "0.3rem" }}>
                          {
                            row.switch_name ? row.switch_name : 'NA'
                            // row.meta.map((item, index1) => {
                            //   return <li key={index1+'___Some___Random__Thing'} className="font-1-2rem mb-0-4rem">
                            //     { item.name } x{item.quantity}
                            //   </li>
                            // })
                          }
                        </div> 

                    //   : 'NA'
                    }
                  </TableRowColumn>
                  <TableRowColumn >
                    {
                    //   row.meta && row.meta[0] && row.meta[0].name ? 
                        <div style={{ fontSize: "0.7rem", paddingLeft: "0.3rem", paddingTop: "0.3rem" }}>
                          {
                            row.switch_state && row.switch_state == "0" ? 'OFF' : "ON"
                            // row.meta.map((item, index1) => {
                            //   return <li key={index1+'___Some___Random__Thing'} className="font-1-2rem mb-0-4rem">
                            //     { item.name } x{item.quantity}
                            //   </li>
                            // })
                          }
                        </div> 

                    //   : 'NA'
                    }
                  </TableRowColumn>

                  {/* <TableHeaderColumn className="v-center">
                    {
                      row.status == "Pending" ?
                        <div className="align-center w-100">
                          <i onClick={this.requestAction.bind(this, 'Accepted', row)} style={{ fontSize: "3rem", cursor: 'pointer', color:'#3abcd4'}} className="material-icons">check_circle</i>

                          <i onClick={this.requestAction.bind(this, 'Rejected', row)} style={{ fontSize: "3rem", cursor: 'pointer'}} className="material-icons warn-fg">cancel</i>

                          {
                            row.meta && row.meta.length ?
                              <i onClick={this.showMeta.bind(this, row)} style={{ fontSize: "3rem", cursor: 'pointer', color:'#3abcd4'}} className="material-icons">visibility</i> 
                            : null
                          }
                        </div> 
                      :
                      <div className="align-center w-100">
                        <span className={row.status == 'Accepted' ? 'secondary-bg white-fg p-4px' : row.status == 'Rejected' ? 'warn-bg white-fg p-4px' : ''}>{row.status}</span>
                      </div>
                    }
                  </TableHeaderColumn> */}
                </TableRow>
              ))
            }
          </TableBody>

          <TableFooter>
            <TableRow>
              <TableRowColumn colSpan="2" style={{ textAlign: 'left' }}>
                {pagination}
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
      </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/services/IntrusionAlertList.js